import React from 'react';
import PropTypes from 'prop-types';
import {
    Col,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Row,
    Card,
    CardHeader,
    Table,
} from 'reactstrap';
import TableHeader from './TableHeader';
import TableBody from './TableBody';
import TableRow from './TableRow';
import TablePagination from './TablePagination';

import style from './style';
import './datatable.css';
import _ from 'lodash';

class Datatable extends React.Component {
    state = {rows: []};
    pageLimits = [5, 10, 15, 20, 50, 100, 200, 500, 1000, 1500, 3000];
    filterData = {};

    constructor(props) {
        super(props);
        let defaultPageLimit = isNaN(props.pageLimit)
            ? this.pageLimits[0]
            : props.pageLimit;
        let defaultCurrentPage = isNaN(props.currentPage)
            ? 1
            : props.currentPage;
        this.state = {
            rows: props.data,
            currentPage: defaultCurrentPage,
            pageNeighbours: props.pageNeighbours,
            pageLimit: defaultPageLimit,
            pageListDropdown: false,
            sortColumn: props.sortColumn,
            totalRecords: props.totalRecords,
        };

        this.header = {...props.header};

        if (this.props.rowAction !== undefined) {
            this.header['actions'] = {name: 'Actions',style: {width: '50px'}};
        }

        this.column = Object.keys(this.header);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (!_.isEqual(nextProps, prevState)) {
            return {...nextProps, rows: nextProps.data}
        } else return null;
    }

    showPaginationStatus = () => {
        if (0 === this.state.rows.length) {
            return false;
        }
        let start = 1;
        let offset = 0;
        if (parseInt(this.state.currentPage) > 1) {
            offset = parseInt(this.state.currentPage - 1) * parseInt(this.state.pageLimit);
            start = offset + 1;
        }
        let end = offset + this.state.rows.length;
        let dynamicPaginationHeaderStyle = {}

        return (
            <center>
                <span style={{...style.paginationHeader, ...dynamicPaginationHeaderStyle}}>
                    Showing {start} to {end} of {this.state.totalRecords} rows{' '}
                </span>

                <Dropdown
                    style={{...style.pageListDropdown, ...dynamicPaginationHeaderStyle}}
                    isOpen={this.state.pageListDropdown}
                    toggle={() => {
                        this.setState({
                            pageListDropdown: !this.state.pageListDropdown,
                        });
                    }}
                    size="sm"

                >

                    <DropdownToggle caret>
                        {this.state.pageLimit}
                    </DropdownToggle>
                    <DropdownMenu>
                        {this.pageLimits.map((limit, key) => {
                            return (
                                <DropdownItem
                                    key={key}
                                    onClick={this.onLimitChanged.bind(
                                        this,
                                        limit
                                    )}
                                >
                                    {limit}
                                </DropdownItem>
                            );
                        })}
                    </DropdownMenu>
                </Dropdown>
                <span style={{...style.paginationHeader, ...dynamicPaginationHeaderStyle}}>Rows Per Page</span>
            </center>
        );
    };

    filter = (event) => {
        this.filterData = {};

        if (event.target.value !== '') {
            this.filterData[event.target.name] = event.target.value;
        } else {
            if (this.filterData[event.target.name]) {
                delete this.filterData[event.target.name];
            }
        }

        if (13 === event.keyCode) {
            this.props.filter(this.filterData);
        }
    };

    onLimitChanged = (pageLimit) => {
        this.setState({pageLimit: pageLimit});
        this.props.onLimitChanged(pageLimit);
    };
    swapDisplayOrder = (event) => {
        let {data} = this.props;
        let selectIndex = event.oldIndex;
        let targetIndex = event.newIndex;
        let record = {
            id: data[selectIndex]['id'],
            oldOrder: data[selectIndex]['display_order'],
            newOrder: data[targetIndex]['display_order'],
        };
        this.props.onDragDrop(record);
    };
    onPageChanged = (pagination) => {
        let {currentPage} = pagination;
        this.setState({currentPage});
        this.props.onPageChanged(pagination);
    };

    render() {
        let HeaderButtons = this.props.headerButtons;

        let isMultiplePages =
            this.state.rows && this.state.totalRecords > this.state.rows.length;

        let isRecordFetched = this.state.rows && this.state.rows.length > 0;
        let columCount = Object.keys(this.header).length;
        return (
            <div className="flex-row align-items-center">
                <Row className="justify-content-center">
                    <Col xs="12" md="12" className="mb-12">
                        <Card>
                            {this.props.onLimitChanged !== undefined ? (
                                <CardHeader>
                                    <Row>
                                        <Col sm="12" xs="12" md="6">
                                            {this.showPaginationStatus()}
                                        </Col>
                                        {this.props.headerButtons !==
                                        undefined ? (
                                            <Col sm="12" xs="12" md="6">
                                                <span
                                                    style={style.headerButtons}
                                                >
                                                    <HeaderButtons/>
                                                </span>{' '}
                                            </Col>
                                        ) : (
                                            ''
                                        )}
                                    </Row>
                                </CardHeader>
                            ) : (
                                ''
                            )}

                            <Table
                                id={this.props.id}
                                responsive
                                bordered
                                style={style.table}
                            >
                                <TableHeader
                                    column={this.column}
                                    header={this.header}
                                    onKeyUp={
                                        this.props.filter &&
                                        this.filter.bind(this)
                                    }
                                    sortColumn={this.state.sortColumn}
                                    onChangeOrder={this.props.onChangeOrder}
                                />

                                <TableBody onDragDrop={this.swapDisplayOrder}>
                                    {isRecordFetched &&
                                    this.state.rows.map((row, key) => (
                                        <TableRow
                                            tableId={this.props.id}
                                            key={key}
                                            rowAction={this.props.rowAction}
                                            cubeAction={
                                                this.props.cubeAction
                                            }
                                            recordsPerPage={
                                                this.state.recordsPerPage
                                            }
                                            column={this.column}
                                            header={this.header}
                                            row={row}
                                            showCubes={this.props.showCubes}
                                            onClickRow={
                                                this.props.onClickRow ||
                                                false
                                            }
                                        />
                                    ))}

                                    {!isRecordFetched && (
                                        <tr>
                                            <td
                                                className="noRecordFound"
                                                colSpan={columCount}
                                            >
                                                No Record Found
                                            </td>
                                        </tr>
                                    )}
                                </TableBody>
                            </Table>
                        </Card>
                        {isMultiplePages &&
                        this.props.onPageChanged !== undefined && (
                            <TablePagination
                                totalRecords={this.state.totalRecords}
                                pageLimit={this.state.pageLimit}
                                currentPage={this.state.currentPage}
                                pageNeighbours={this.state.pageNeighbours}
                                onPageChanged={this.onPageChanged}
                            />
                        )}
                    </Col>
                </Row>
            </div>
        );
    }
}

Datatable.propTypes = {
    header: PropTypes.object.isRequired,
    data: PropTypes.array.isRequired,
    currentPage: PropTypes.number,
    pageNeighbours: PropTypes.number,
    pageLimit: PropTypes.number,
    totalRecords: PropTypes.number,
    sortColumn: PropTypes.object,
    filter: PropTypes.func,
    onLimitChanged: PropTypes.func,
    onPageChanged: PropTypes.func,
    headerButtons: PropTypes.func,
    onDragDrop: PropTypes.func,
    onChangeOrder: PropTypes.func,
    rowAction: PropTypes.func,
    onClickRow: PropTypes.func,
    id: PropTypes.any,
    showCubes: PropTypes.any,
    cubeAction: PropTypes.any,
};
Datatable.defaultProps = {
    id: `datatable_${Math.floor(Math.random() * 100)}`,
};
export default Datatable;
